import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import { PieChartOutlined, DesktopOutlined, UserOutlined, FileOutlined, TeamOutlined, UserAddOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SidebarMenu from "../components/SidebarMenu/SidebarMenu";
import { Module } from "../types/Module"; // Ensure you have this type
import { customThemes } from '../themeConfig';
import { useRef } from 'react';

const { Sider } = Layout;

type SidebarProps = {
  collapsed: boolean;
  darkMode: boolean;
  themeStyles: {
    headerBg: string;
    siderBg: string;
    footerBg: string;
  };
  isMobile: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  darkMode,
  // themeStyles,
  isMobile,
}) => {
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState<string>('1');
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const modules = useSelector((state: any) => state.user?.modules); // Assuming user modules are in redux state
  const user = useSelector((state: any) => state.user?.user);
  const logo_url = process.env.REACT_APP_FILE_URL + 'uploads/organizations/logo/' + user.organization_logo
  // console.log(modules);
  // Extract current path
  const currentPath = location.pathname;
  const themeStyles = darkMode ? customThemes.dark : customThemes.light;
   const siderRef = useRef<HTMLDivElement | null>(null);



  // Set selected key based on the current path
  useEffect(() => {
    let activeKey = '1'; // Default key (e.g., Dashboard)
    const checkPath = (path: string) => {
      // Iterate through modules and check if the path matches
      for (const module of modules) {
        if (module.module_url === path) {
          activeKey = String(module.module_id);
          break;
        }
        // If there are children, check if the path is within a child
        if (module.children && module.children.some((child: Module) => child.module_url === path)) {
          activeKey = String(module.module_id);
          break;
        }
      }
      setSelectedKey(activeKey);
    };

    checkPath(currentPath);
  }, [currentPath, modules]);

  // Set open keys based on the current path
  useEffect(() => {
    const setOpenSubMenu = (path: string) => {
      const openSubKeys: string[] = [];
      for (const module of modules) {
        if (module.children && module.children.some((child: Module) => child.module_url === path)) {
          openSubKeys.push(String(module.module_id)); // Open the parent submenu
        }
      }
      setOpenKeys(openSubKeys); // Update the open keys state
    };

    setOpenSubMenu(currentPath);
  }, [currentPath, modules]);


  return (
    <Sider
      trigger={null}
      width={296}
      collapsible
      collapsed={collapsed}
      breakpoint="lg"
      collapsedWidth={isMobile ? '0' : '70'} // Collapse to width 0 on mobile
      theme={darkMode ? 'light' : 'dark'}
      ref={siderRef}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'sticky',
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable',
        backgroundColor: themeStyles.siderBg,
      }}
    >
      <div
        style={{
          height: 64,
          margin: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingRight: 0,
          marginRight: 0,
        }}
      >
        <img
          src={
            collapsed
              ? (user.organization_logo ? logo_url : '/favicon2.ico')
              : (user.organization_logo ? logo_url : '/logo192.png')
          }
          alt="Logo"
          style={{
            height: 32,
            transition: 'all 0.3s ease',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Use SidebarMenu Component */}
      <SidebarMenu
        modules={modules}
        selectedKey={selectedKey}
        openKeys={openKeys}
        darkMode={darkMode}
        themeStyles={themeStyles}
        siderRef={siderRef}
      />
    </Sider>
  );
};

export default Sidebar;
